<!-- =========================================================================================
  File Name: DataListThumbView.vue
  Description: Data List - Thumb View
  ----------------------------------------------------------------------------------------
  Item Name: Vuexy - Vuejs, HTML & Laravel Admin Dashboard Template
  Author: Pixinvent
  Author URL: http://www.themeforest.net/user/pixinvent
========================================================================================== -->

<template>
  <div>
    <vx-card title>
      <div class="mt-5">
        <div class="vx-row">
          <div class="vx-col md:w-1/3 mt-5">
            <h6 class="mb-2">Motivo</h6>
          </div>
          <div class="vx-col md:w-1/5 mt-5">
            <h6 class="mb-2">Data</h6>
          </div>
           <div class="vx-col md:w-1/3 mt-5">
            <h6 class="mb-2">Observação</h6>
          </div>
        </div>
        <div class="vx-row">
          <div class="vx-col md:w-1/3 w-1/3 mt-5">
            <vs-input class="w-full" v-model="namePrice" />
          </div>
          <div class="vx-col md:w-1/5 w-1/5 mt-5">
            <datepicker
              placeholder="Selecione a Data"
              :language="languages['ptBR']"
              format="dd/MM/yyyy"
              v-model="date"
            ></datepicker>
          </div>
           <div class="vx-col md:w-1/3 w-1/3 mt-5">
            <vs-input class="w-full" v-model="obs" />
          </div>
        </div>
        <div class="vx-row">
          <div class="vx-col md:w-1/4 mt-5">
            <h6 class="mb-2">Fornecedores</h6>
          </div>
        </div>
        <div class="vx-row">
          <div class="vx-col md:w-1/4 mt-5">
            <vs-input class="w-full" v-model="distributor" />
          </div>
          <div class="vx-col md:w-1/4 mt-5">
            <vs-button
              color="success"
              icon-pack="feather"
              icon="icon-plus"
              @click="addDistributors"
            ></vs-button>
          </div>
        </div>
      </div>
    </vx-card>
    <div id="data-list-thumb-view" class="data-list-container">
      <br />
      <vx-card title>
        <div class="mt-5">
          <div class="vx-row">
            <div class="vx-col md:w-1/2 w-full mt-5">
              <h6 class="mb-2">Produto</h6>
              <v-select :options="getProducts" label="label" v-model="product">
                <template slot="option" slot-scope="option">
                  <img
                    :src="option.image"
                    width="40"
                    height="40"
                    class="rounded-full shadow-md cursor-pointer block"
                  />
                  {{ option.label }}
                </template>
              </v-select>
            </div>
          </div>
          <div class="vx-row">
            <div class="vx-col md:w-1/12 mt-5">
              <h6 class="mb-2">ICMS</h6>
              <vs-input class="w-full" v-model="icmsState" />
            </div>
          </div>
          <div v-for="(item, index) of items" :key="index">
            <div class="vx-row">
              <div class="vx-col md:w-1/3 w-1/3 mt-5">
                <h1 class="mb-2">{{ item.distributor }}</h1>
              </div>
            </div>
            <div class="vx-row">
              <div class="vx-col md:w-1/1 w-1/1 mt-5">
                <h6 class="mb-2">Valor Unitário</h6>
                <vs-input
                  class="w-full"
                  v-model="item.price"
                  v-currency="{ currency: 'BRL', locale: 'pt-br' }"
                  @input="handleTotal(item, index)"
                />
              </div>
              <div class="vx-col md:w-1/1 w-1/1 mt-5">
                <h6 class="mb-2">Quantidade</h6>
                <vs-input-number
                  class="w-full"
                  v-model="item.amount"
                  @input="handleTotal(item, index)"
                />
              </div>
              <div class="vx-col md:w-1/1 w-1/1 mt-5">
                <h6 class="mb-2">ICMS</h6>
                <vs-input
                  class="w-full"
                  v-model="item.icms"
                  @input="handleTotal(item, index)"
                />
              </div>
              <div class="vx-col md:w-1/1 w-1/1 mt-5">
                <h6 class="mb-2">Diferença</h6>
                <vs-input
                  class="w-full"
                  v-model="item.difference"
                  v-currency="{ currency: 'BRL', locale: 'pt-br' }"
                  disabled
                />
              </div>
              <div class="vx-col md:w-1/1 w-1/1 mt-5">
                <h6 class="mb-2">Total</h6>
                <vs-input
                  disabled
                  class="w-full"
                  v-model="item.total"
                  v-currency="{ currency: 'BRL', locale: 'pt-br' }"
                />
              </div>
              <div class="vx-col md:w-1/1 w-1/1 mt-5">
                <h6 class="mb-2">Apagar</h6>
                <vs-button
                  color="danger"
                  icon-pack="feather"
                  icon="icon-trash"
                  @click="deleteItem(index)"
                ></vs-button>
              </div>
            </div>
          </div>
        </div>
        <div class="vx-row">
          <div class="vx-col md:w-1/1 w-full mt-5">
            <vs-button
              class="float-right"
              color="success"
              v-show="product"
              @click="addItem"
              >Adicionar</vs-button
            >
          </div>
        </div>
      </vx-card>
      <br />
      <vx-card title="Produtos Gerais">
        <vue-good-table
          ref="my-table"
          selectionInfoClass="mytable"
          style="width: 100%"
          styleClass="vgt-table condensed"
          :search-options="{
            enabled: true,
            trigger: '',
            placeholder: 'Procurar',
            skipDiacritics: true,
          }"
          :pagination-options="paginationOptions"
          :columns="columns"
          :rows="productsSelected"
          @on-row-click="onRowClick"
        >
          <div slot="emptystate" class="text-center">
            Nenhum resultado encontrado
          </div>
          <template slot="table-row" slot-scope="item">
            <span class="font-medium" v-if="item.column.field == 'idProduct'">
              <div v-show="item.row.lowerValue == true">
                <vs-chip color="success">{{ item.row.idProduct }}</vs-chip>
              </div>
              <div
                v-show="
                  item.row.lowerValue == undefined || item.row.lowerValue == 0
                "
              >
                <vs-chip color="danger">{{ item.row.idProduct }}</vs-chip>
              </div>
            </span>
            <span class="font-medium" v-if="item.column.field == 'name'">
              {{ item.row.name }}
            </span>
            <span class="font-medium" v-if="item.column.field == 'rawPrice'">
              {{ item.row.rawPrice }}
            </span>
            <span class="font-medium" v-if="item.column.field == 'amount'">
              {{ item.row.amount }}
            </span>
            <span class="font-medium" v-if="item.column.field == 'icms'">
              {{ item.row.icms }}
            </span>
            <span class="font-medium" v-if="item.column.field == 'difference'">
              {{ item.row.difference }}
            </span>
            <span class="font-medium" v-if="item.column.field == 'total'">
              {{ item.row.total }}
            </span>
            <span class="font-medium" v-if="item.column.field == 'distributor'">
              {{ item.row.distributor }}
            </span>
            <span class="font-medium" v-if="item.column.field == 'action'">
              <vs-button
                color="danger"
                icon-pack="feather"
                icon="icon-trash"
                @click="deleteSelectedProduct(item.row.originalIndex)"
              ></vs-button>
            </span>
          </template>
        </vue-good-table>
      </vx-card>
      <br />
      <vx-card title="Melhores Produtos">
        <vue-good-table
          ref="my-table"
          selectionInfoClass="mytable"
          style="width: 100%"
          styleClass="vgt-table condensed"
          :search-options="{
            enabled: true,
            trigger: '',
            placeholder: 'Procurar',
            skipDiacritics: true,
          }"
          :pagination-options="paginationOptions"
          :columns="columns"
          :rows="productsSelected"
          @on-row-click="onRowClick"
        >
          <div slot="emptystate" class="text-center">
            Nenhum resultado encontrado
          </div>
          <template slot="table-row" slot-scope="item">
            <div v-show="item.row.lowerValue == true">
              <span class="font-medium" v-if="item.column.field == 'idProduct'">
                <vs-chip color="success">{{ item.row.idProduct }}</vs-chip>
              </span>
              <span class="font-medium" v-if="item.column.field == 'name'">
                {{ item.row.name }}
              </span>
              <span class="font-medium" v-if="item.column.field == 'rawPrice'">
                {{ item.row.rawPrice }}
              </span>
              <span class="font-medium" v-if="item.column.field == 'amount'">
                {{ item.row.amount }}
              </span>
              <span class="font-medium" v-if="item.column.field == 'icms'">
                {{ item.row.icms }}
              </span>
              <span
                class="font-medium"
                v-if="item.column.field == 'difference'"
              >
                {{ item.row.difference }}
              </span>
              <span class="font-medium" v-if="item.column.field == 'total'">
                {{ item.row.total }}
              </span>
              <span
                class="font-medium"
                v-if="item.column.field == 'distributor'"
              >
                {{ item.row.distributor }}
              </span>
              <span class="font-medium" v-if="item.column.field == 'action'">
              </span>
            </div>
          </template>
        </vue-good-table>
      </vx-card>
      <div class="mt-5">
        <div class="vx-row">
          <div class="vx-col md:w-1/1 w-full mt-5">
            <vs-button
              v-show="productsSelected.length > 0"
              class="float-right"
              color="success"
              @click="submit"
              >Salvar</vs-button
            >
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { momentJS, numberJS } from "@/helpers";
import { VueGoodTable } from "vue-good-table";
import vSelect from "vue-select";
import Datepicker from "vuejs-datepicker";
import * as lang from "vuejs-datepicker/src/locale";
import { baseApiUrl } from "@/global";
import router from "@/router";
import axios from "axios";
import { Validator } from "vee-validate";
const dict = {
  custom: {
    customer: {
      required: "Selecione o cliente",
    },
    user: {
      required: "Selecione o Consultor",
    },
  },
};

Validator.localize("en", dict);
export default {
  components: { vSelect, Datepicker, VueGoodTable },
  props: {},
  data() {
    return {
      idPrices: null,
      date: null,
      obs: null,
      namePrice: null,
      distributor: "",
      items: [],
      icmsState: 17,
      languages: lang,
      contractCustomerSelected: [],
      product: null,
      name: null,
      price: null,
      amount: null,
      icms: null,
      difference: null,
      total: null,
      productsSelected: [],
      columns: [],
      paginationOptions: {
        enabled: true,
        nextLabel: "Próxima",
        prevLabel: "Anterior",
        rowsPerPageLabel: "Resultados por página",
        ofLabel: "de",
        pageLabel: "Página",
        allLabel: "Todos",
        mode: "pages",
        perPage: 50,
      },
    };
  },
  computed: {
    getProducts() {
      let products = _.cloneDeep(this.$store.state.products);
      products.forEach((element) => {
        element.id = element.idProduct;
        element.label = `${element.name} | ${element.code}`;
        element.image = element.photoProduct;
      });
      return products;
    },
  },
  methods: {
    format(price) {
      price = parseFloat(
        price.replace("R$", "").replace(".", "").replace(",", ".").trim()
      );
      return price;
    },
    addDistributors() {
      this.items.push({ distributor: this.distributor, amount: 1 });
      this.distributor = "";
    },
    handleTotal(item, index) {
      let total;
      let price = item.price;
      let resultIcms = parseInt(this.icmsState) - parseInt(item.icms);
      let amount = parseInt(item.amount);
      price = this.format(price);
      let difference = (resultIcms / 100) * price * amount;
      this.items[index].difference = numberJS().formatBRL(difference);
      price = this.format(item.price);
      total = price * item.amount;
      this.items[index].total = numberJS().formatBRL(total + difference);
    },
    addItem() {
      try {
        let localItems = this.items;
        for (const element of localItems) {
          if (element.price) {
            element.rawPrice = element.price;
            element.price = this.format(element.price);
          }
          element.idProduct = this.product.idProduct;
          element.name = this.product.name;
        }
        localItems = _.orderBy(localItems, ["price"], ["asc"]);
        localItems[0].lowerValue = true;

        for (const iterator of localItems) {
          this.productsSelected.push(iterator);
        }
        this.product = null;
        this.items = [];
        this.$vs.notify({
          title: "Adicionado",
          text: "Com Sucesso.",
          iconPack: "feather",
          icon: "icon-alert-circle",
          color: "success",
        });
      } catch (error) {
        console.log(error);
        this.$vs.notify({
          title: "Erro",
          text: "Problema ao Adicionar",
          iconPack: "feather",
          icon: "icon-alert-circle",
          color: "danger",
        });
      }
    },
    async submit() {
      this.$vs.loading();
      try {
        let data = {
          idPrices: this.idPrices,
          namePrice: this.namePrice,
          obs: this.obs,
          date: this.date,
          items: this.productsSelected,
        };
        const response = await axios.post(`${baseApiUrl}/prices/update`, data);
        this.$vs.notify({
          title: "Salvo",
          text: "Com Sucesso.",
          iconPack: "feather",
          icon: "icon-alert-circle",
          color: "success",
        });
        if (response.status == "200") {
          router.push("/cotacoes").catch(() => {});
        }
      } catch (error) {
        if (!error.response || !error.response.data) return;
        this.$vs.notify({
          title: "Ocorreu algum problema",
          text: error.response.data,
          iconPack: "feather",
          icon: "icon-alert-circle",
          color: "warning",
        });
      } finally {
        this.$vs.loading.close();
      }
    },
    onRowClick(params) {
      // Somente para ter a mão do mouse clique
    },
    mountTable() {
      this.columns = [
        {
          label: "Código",
          field: "idProduct",
          tdClass: "align-middle",
        },
        {
          label: "Produto",
          field: "name",
          tdClass: "align-middle",
        },
        {
          label: "Preço",
          field: "rawPrice",
          tdClass: "align-middle",
        },
        {
          label: "Quantidade",
          field: "amount",
          tdClass: "align-middle",
        },
        {
          label: "ICMS",
          field: "icms",
          tdClass: "align-middle",
        },
        {
          label: "Diferença",
          field: "difference",
          tdClass: "align-middle",
        },
        {
          label: "Total",
          field: "total",
          tdClass: "align-middle",
        },
        {
          label: "Distribuidor",
          field: "distributor",
          tdClass: "align-middle",
        },
        {
          label: "Ações",
          field: "action",
          tdClass: "align-middle",
        },
      ];
    },
    deleteItem(index) {
      this.items.splice(index, 1);
    },
    deleteSelectedProduct(index) {
      if (this.productsSelected.length == 1) {
        this.productsSelected = [];
        return;
      }
      if (this.productsSelected.length - 1 == index) {
        this.productsSelected.splice(index, 1);
        return;
      }
      this.productsSelected[index + 1].lowerValue = true;
      this.productsSelected.splice(index, 1);
    },
  },
  async created() {
    this.date = momentJS().getDateTimeLocal();
    this.mountTable();

    this.$vs.loading();
    try {
      const response = await axios.get(
        `${baseApiUrl}/prices/getPricesAndItemsById/${this.$route.params.idPrices}`
      );
      if (response.data.length == 0) {
        router.push("/cotacoes").catch(() => {});
      }
      this.idPrices = response.data[0].fk_idPrices;
      this.namePrice = response.data[0].namePrice;
      this.date = response.data[0].date;
      this.obs = response.data[0].obs;
      let items = response.data;
      items.forEach((element) => {
        delete element.date;
        element.idProduct = element.fk_idProduct;
        delete element.fk_idProduct;
        delete element.fk_idPrices;
      });
      this.productsSelected = items;
      this.$vs.loading.close();
    } catch (error) {
      if (!error.response || !error.response.data) return;
      this.$vs.notify({
        title: "Ocorreu algum problema",
        text: error.response.data,
        iconPack: "feather",
        icon: "icon-alert-circle",
        color: "warning",
      });
    } finally {
      this.$vs.loading.close();
    }

    let payload = {
      loading: this.$vs.loading,
    };
    this.$store.dispatch("fetchProductsItems", payload);
  },
};
</script>

<style lang="scss">
#data-list-thumb-view {
  .vs-con-table {
    .product-name {
      max-width: 23rem;
    }
    .vs-table--header {
      display: flex;
      flex-wrap: wrap-reverse;
      margin-left: 1.5rem;
      margin-right: 1.5rem;
      > span {
        display: flex;
        flex-grow: 1;
      }
      .vs-table--search {
        padding-top: 0;
        .vs-table--search-input {
          padding: 0.9rem 2.5rem;
          font-size: 1rem;
          & + i {
            left: 1rem;
          }
          &:focus + i {
            left: 1rem;
          }
        }
      }
    }
    .vs-table {
      border-collapse: separate;
      border-spacing: 0 1.3rem;
      padding: 0 1rem;
      tr {
        box-shadow: 0 4px 20px 0 rgba(0, 0, 0, 0.05);
        td {
          padding: 10px;
          &:first-child {
            border-top-left-radius: 0.5rem;
            border-bottom-left-radius: 0.5rem;
          }
          &:last-child {
            border-top-right-radius: 0.5rem;
            border-bottom-right-radius: 0.5rem;
          }
          &.img-container {
            // width: 1rem;
            // background: #fff;
            span {
              display: flex;
              justify-content: flex-start;
            }
            .product-img {
              height: 110px;
            }
          }
        }
        td.td-check {
          padding: 20px !important;
        }
      }
    }
    .vs-table--thead {
      th {
        padding-top: 0;
        padding-bottom: 0;
        .vs-table-text {
          text-transform: uppercase;
          font-weight: 600;
        }
      }
      th.td-check {
        padding: 0 15px !important;
      }
      tr {
        background: none;
        box-shadow: none;
      }
    }
    .vs-table--pagination {
      justify-content: center;
    }
  }
}
</style>